<template>
  <div style="width: auto" class="d-flex justify-center py-1">
    <section v-if="!isCollapsed" class="nfe-card pa-2 py-3">
      <v-card-text class="d-flex justify-space-between pa-0" style="font-size: 1rem">
        <div v-if="isLongText(unallocatedNfe.nameRecipient)">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate" v-bind="attrs" v-on="on">
                <span class="font-weight-bold">Destinatário: </span>
                <span :class="['font-weight-regular', { 'subtitle-2': isNameRecipientUppercase }]">{{
                  truncateText(unallocatedNfe.nameRecipient)
                }}</span>
              </div>
            </template>
            <span>{{ unallocatedNfe.nameRecipient }}</span>
          </v-tooltip>
        </div>
        <div v-else class="text-truncate">
          <span class="font-weight-bold">Destinatário: </span>
          <span :class="['font-weight-regular', { 'subtitle-2': isNameRecipientUppercase }]">{{
            unallocatedNfe.nameRecipient
          }}</span>
        </div>
        <div class="d-flex">
          <v-checkbox v-model="localSelected" class="checkbox-nfe ma-0 pa-0" hide-details></v-checkbox>
          <v-icon class="handle-drag" v-show="isDragable" size="24">mdi-drag</v-icon>
          <v-icon size="24" v-show="isDelete" color="red" @click="$emit('openDialogDelete', unallocatedNfe, false)"
            >mdi-trash-can-outline</v-icon
          >
        </div>
      </v-card-text>
      <v-card-text v-show="isDragable" class="d-flex pa-0 pt-3">
        <v-row>
          <v-col class="pa-0 pl-3" cols="12" md="12">
            <span class="font-weight-bold span-nfe text--secondary">CPF/CNPJ: </span>
            <span class="font-weight-regular span-nfe pr-2">{{
              transformCpfOrCnpj(unallocatedNfe.cpfCnpjRecipient || '')
            }}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text class="d-flex pa-0 pt-3" style="font-size: 1rem">
        <div v-if="isLongText(unallocatedNfe.nameSender)">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate" v-bind="attrs" v-on="on">
                <span class="font-weight-bold">Remetente: </span>
                <span :class="['font-weight-regular', { 'subtitle-2': isNameSenderUppercase }]">{{
                  truncateText(unallocatedNfe?.nameSender)
                }}</span>
              </div>
            </template>
            <span>{{ unallocatedNfe?.nameSender }}</span>
          </v-tooltip>
        </div>
        <div v-else class="text-truncate">
          <span class="font-weight-bold">Remetente:</span>
          <span :class="['font-weight-regular', { 'subtitle-2': isNameSenderUppercase }]">{{
            unallocatedNfe?.nameSender
          }}</span>
        </div>
      </v-card-text>

      <v-card-text v-show="isDragable" class="d-flex pa-0 py-3">
        <v-row>
          <v-col class="pa-0 pl-3" cols="12" md="12">
            <span class="font-weight-bold span-nfe text--secondary">CPF/CNPJ: </span>

            <v-tooltip v-if="hasMultipleCpfCnpj(unallocatedNfe.cpfCnpjSender || '')" bottom>
              <template v-slot:activator="{ on, attrs }">
                <span class="font-weight-regular span-nfe pr-2 text-truncate" v-bind="attrs" v-on="on">{{
                  truncateText(transformCpfOrCnpj(unallocatedNfe.cpfCnpjSender || ''))
                }}</span>
              </template>
              <span>{{ unallocatedNfe?.cpfCnpjSender }}</span>
            </v-tooltip>
            <span class="font-weight-regular span-nfe pr-2">{{
              transformCpfOrCnpj(unallocatedNfe.cpfCnpjSender || '')
            }}</span>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text class="d-flex px-0 py-3">
        <v-row>
          <v-col class="pa-0 pl-3" cols="12" md="12">
            <span class="font-weight-bold text--secondary">Peso: </span>
            <span class="font-weight-regular pr-2">{{ formatWeight(unallocatedNfe.weight) }}kg</span>
            <span class="font-weight-bold text--secondary">Preço: </span>
            <span class="font-weight-regular">{{ formatPrice(unallocatedNfe.price) }}</span>
          </v-col>
          <v-col class="pa-0 pl-3" cols="12" md="12">
            <span class="font-weight-bold text--secondary">Número NFe: </span>
            <span>
              <v-tooltip color="transparent" right nudge-left="25" nudge-bottom="30" max-width="330">
                <template v-slot:activator="{ on, attrs }">
                  <span class="font-weight-regular">{{ unallocatedNfe.number }}</span>
                  <v-icon small @click="copy(unallocatedNfe.accessKey)" v-bind="attrs" v-on="on">
                    mdi-checkbox-multiple-blank-outline
                  </v-icon>
                </template>
                <span class="open-box">
                  <v-card>
                    <v-card-text class="p-1" style="font-size: 10px; padding-top: 5px; padding-bottom: 5px">
                      Clique para copiar a chave de acesso:
                      {{ unallocatedNfe.accessKey }}
                    </v-card-text>
                  </v-card>
                </span>
              </v-tooltip>
            </span>
          </v-col>
        </v-row>
      </v-card-text>
    </section>
    <section v-else class="nfe-card-collapsed pa-0">
      <v-card-text class="w-100 d-flex justify-space-between pa-0 pt-1" style="font-size: 0.95rem">
        <v-col class="pa-0 pl-2" cols="auto">
          <span class="font-weight-regular text--secondary">Número NFe:</span>
        </v-col>
        <v-col class="d-flex pa-0 pl-3" cols="auto">
          <v-checkbox v-model="localSelected" class="checkbox-nfe ma-0 pa-0" hide-details></v-checkbox>
          <v-icon class="handle-drag" v-show="isDragable" size="24">mdi-drag</v-icon>
          <v-icon size="24" v-show="isDelete" color="red" @click="$emit('openDialogDelete', unallocatedNfe, false)"
            >mdi-trash-can-outline</v-icon
          >
        </v-col>
      </v-card-text>
      <v-card-text class="w-100 d-flex px-0 py-0" style="font-size: 1rem">
        <v-col class="pa-0 pl-2" cols="12">
          <span>
            <v-tooltip color="transparent" right nudge-left="20" nudge-bottom="30" max-width="330">
              <template v-slot:activator="{ on, attrs }">
                <span class="font-weight-medium">{{ unallocatedNfe.number }}</span>
                <v-icon small @click="copy(unallocatedNfe.accessKey)" v-bind="attrs" v-on="on">
                  mdi-checkbox-multiple-blank-outline
                </v-icon>
              </template>
              <span class="open-box">
                <v-card>
                  <v-card-text class="p-1" style="font-size: 10px; padding-top: 5px; padding-bottom: 5px">
                    Clique para copiar a chave de acesso:
                    {{ unallocatedNfe.accessKey }}
                  </v-card-text>
                </v-card>
              </span>
            </v-tooltip>
          </span>
        </v-col>
      </v-card-text>
    </section>
  </div>
</template>

<script>
import copyToClipboard from '@/utils/copyToClipboard';
import maskPrice from '@/utils/maskPrice';
import maskWeight from '@/utils/maskWeight';
import maskCPF from '@/utils/maskCPF';
import maskCNPJ from '@/utils/maskCNPJ';

export default {
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    isCollapsed: {
      type: Boolean,
      default: false
    },
    unallocatedNfe: {
      type: Object,
      default: () => {}
    },
    isDragable: {
      type: Boolean,
      default: false
    },
    isDelete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      numberNfe: this.unallocatedNfe.accessKey ? this.unallocatedNfe.accessKey.substring(25, 34) : ''
    };
  },
  watch: {
    accessKeyNfe(newVal) {
      this.numberNfe = newVal ? newVal.substring(25, 34) : '';
    }
  },
  computed: {
    localSelected: {
      get() {
        return this.selected;
      },
      set(value) {
        this.$emit('update:selected', value);
      }
    },
    isNameRecipientUppercase() {
      return this.unallocatedNfe.nameRecipient === this.unallocatedNfe.nameRecipient.toUpperCase();
    },
    isNameSenderUppercase() {
      return this.unallocatedNfe.nameSender === this.unallocatedNfe.nameSender.toUpperCase();
    }
  },
  methods: {
    copy(str) {
      copyToClipboard(str);
    },
    transformCpfOrCnpj(str) {
      if (str.length === 11) {
        return maskCPF(str);
      }
      return maskCNPJ(str) || str;
    },
    isLongText(text, limit = 20) {
      return text.length > limit;
    },
    truncateText(text, limit = 20) {
      return text.length > limit ? text.substring(0, limit - 3) + '...' : text;
    },
    formatPrice(price) {
      return maskPrice(price);
    },
    formatWeight(price) {
      return maskWeight(price);
    },
    hasMultipleCpfCnpj(cpfCnpj) {
      return cpfCnpj.includes(',');
    }
  }
};
</script>

<style scoped>
* {
  transition: 0ms;
}
.span-nfe {
  font-size: 13px;
}
.nfe-card {
  width: 350px;
  height: auto;
  border-radius: 3px;
  border: solid 1px #f1f1f1;
  box-shadow: 1px 4px 3px rgba(23, 23, 23, 0.28);
}
.nfe-card-collapsed {
  width: 220px;
  height: 54px;
  border-radius: 3px;
  border: solid 1px #f1f1f1;
  box-shadow: 1px 4px 3px rgba(23, 23, 23, 0.28);
}
.checkbox-nfe {
  margin-top: 2px;
}
::v-deep .checkbox-nfe .v-input--selection-controls__input {
  margin-right: 0px;
}
</style>
